export const GET_CANDIDATE_RECOMMENDED_REQUEST =
  "GET_CANDIDATE_RECOMMENDED_REQUEST";


export const SAVE_CANDIDATE_JOB_APPLICATION_STATUS_REQUEST =
  "SAVE_CANDIDATE_JOB_APPLICATION_STATUS_REQUEST";

export const SCHEDULE_CANDIDATE_INTERVIEW_REQUEST =
  "SCHEDULE_CANDIDATE_INTERVIEW_REQUEST";

export const SAVE_IGNORE_CANDIDATE_FROM_RECOMMENDATION_REQUEST =
  "SAVE_IGNORE_CANDIDATE_FROM_RECOMMENDATION_REQUEST";

export const SAVE_CANDIDATE_REJECT_STATUS_REQUEST =
  "SAVE_CANDIDATE_REJECT_STATUS_REQUEST";
